export default __webpack_public_path__ + "static/media/tosg-red.4ce422c8.png";